module.exports = __webpack_public_path__ + "img/d.a5f1c914.jpg";